/**
 * StatisticsCard Component - Uses shadcn/ui Card component
 * Enhanced with Badge for trend display
 */
import { memo } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface StatisticsCardProps {
  title: string;
  value: React.ReactNode;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  detail?: React.ReactNode;
  trend?: React.ReactNode;
  trendColor?: 'green' | 'red';
  className?: string;
}

const StatisticsCard = memo(({
  title,
  value,
  icon: Icon,
  detail,
  trend,
  trendColor = "green",
  className
}: StatisticsCardProps) => {
  return (
    <Card className={className}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {title}
        </CardTitle>
        {Icon && <Icon className="h-5 w-5 text-muted-foreground" />}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        {detail && (
          <p className="text-xs text-muted-foreground mt-1">{detail}</p>
        )}
        {trend && (
          <Badge 
            variant="outline" 
            className={cn(
              "text-xs mt-1",
              trendColor === 'green' ? 'border-success/50 text-success' : 'border-destructive/50 text-destructive'
            )}
          >
            {trend}
          </Badge>
        )}
      </CardContent>
    </Card>
  );
});

StatisticsCard.displayName = 'StatisticsCard';

export default StatisticsCard;
